import {AnalyticsLogger} from "../../core/common/logger";
import NullTracker from "../../core/analytics/trackers/null";
import {events} from "../../core/analytics/ecommerce/events";
import {orderSuccessful} from "./handlers";
import GoogleAnalyticsTracker from "./ga";

function makeGoogleAnalyticsTracker(key) {
  AnalyticsLogger.debug("makeGoogleAnalyticsTracker: " + key);
  const tracker = key ? new GoogleAnalyticsTracker(key) : new NullTracker();
  if (key) {
    tracker.addHandler(events.ORDER_SUCCESSFUL, orderSuccessful);
  }

  return tracker;
}

export default makeGoogleAnalyticsTracker;
